<template>
  <form-save-nomenclature
    :visible="visible"
    :cur-bid="bidId"
    :status-download="statusDownloadNomenclature"
    :link-download="linkDownloadNomenclature"
    page="loadDay"
    @save="saveNomenclature"
    @close="closeNomenclature"
  />
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE } from '@/store/actions/loadDay'
import { SET_PROGRESS_BAR, SET_STATUS_DOWNLOAD } from '@/store/actions/reports'
import { mapGetters } from 'vuex'
import FormSaveNomenclature from '@/components/Forms/FormSaveNomenclature'

const DocAPI = RepositoryFactory.get('doc')

export default {
  name: 'SaveNomenclature',
  components: { FormSaveNomenclature },
  props: {
    bidId: {
      type: Number,
      default: null,
    },
    loadDaysIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      linkDownloadNomenclature: '',
    }
  },
  computed: {
    ...mapGetters({
      visible: 'loadDay/getIsShowDialogSaveNomenclature',
      selectedResponseIds: 'loadDay/getSelected',
    }),
    statusDownloadNomenclature: {
      get() {
        return this.$store.getters[`reports/getStatusDownload`]
      },
      set(value) {
        this.$store.dispatch(`reports/${SET_STATUS_DOWNLOAD}`, value)
      },
    },
  },
  methods: {
    async createReport() {
      const objIds = this.loadDaysIds.length
        ? { load_day_ids: this.loadDaysIds }
        : { response_ids: this.selectedResponseIds }

      await DocAPI.createReport('random', objIds, 0)
        .then(response => {
          if (response.data.errors.length) {
            this.$message.error(response.data.errors.join())
            this.statusDownloadNomenclature = 'error'

            return null
          }

          return response.data.model.id
        })
        .catch(e => this.$message.error(e))
    },
    async saveNomenclature(options) {
      const reportId = await this.createReport()

      reportId &&
        (await DocAPI.generateReport(
          reportId,
          options.scoupe,
          options.watermark,
          options.combine,
          options.item,
        )
          .then(response => {
            this.$message('Загрузка отчет скоро начнется')
            const reportId = response.data.id
            let timer = setInterval(() => {
              DocAPI.getReportFiles('total-report', reportId).then(res => {
                this.$store.dispatch(
                  `reports/${SET_PROGRESS_BAR}`,
                  res.data.readiness,
                )

                if (res.data.readiness === 100) {
                  this.$message('Загрузка отчета началась')
                  setTimeout(() => {
                    const path = DocAPI.getReportLink(
                      `total-report/${reportId}/download`,
                    )

                    this.downloadRegistry({ path })
                    this.statusDownloadNomenclature = 'ready'
                    clearInterval(timer)
                  }, 1000)
                }
              })
            }, 2000)
          })
          .catch(() => {
            this.$message('Что то пошло не так')
          }))
    },
    closeNomenclature() {
      this.$store.dispatch(
        `loadDay/${SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE}`,
        false,
      )
      this.statusDownloadNomenclature = ''
    },
  },
}
</script>

<style lang="sass"></style>
